// initialize a group of sliders that are restricted to a total (e.g. make sure multiple sliders don't add to more than 100%)
export const slidersInit = ($this) => {
    var section = $this.data('section');
    var handle = $('<div class="custom-handle ui-slider-handle handle-' + section + '"></div>');
    var input = $this.closest('.form-group.section-' + section).find('input[type=hidden]');
    var sliderVal = $this.closest('.form-group.section-' + section).find('.slider-val-' + section);
    var sliderTotal = $('#milestone-section-' + section + ' span#slider-total-' + section);
    handle.appendTo($this);
    $this.slider({
        value: $this.data('value') ?? 0,
        min: $this.data('min'),
        max: $this.data('max'),
        range: 'min',
        create: function (event, ui) {
            handle.text($this.slider('value'));
            $this.addClass('has' + section + 'Slider');
            updateGroup($this, $this.slider('value'));
        },
        slide: function (event, ui) {
            if ($this.hasClass('slider-pool-' + section)) {
                return false;
            }
            var update = updateGroup($this, ui.value);
            if (!update) {
                return false;
            }

            handle.text(ui.value);
            sliderVal.text(ui.value);
        },
    });
    $this.on('slidechange', function (event, ui) {
        if ($this.hasClass('slider-pool-' + section)) {
            sliderTotal.text(ui.value);
        }
        handle.text(ui.value);
        input.val(ui.value);
    });
};
// update the sliderInit sliders when a value changes
export const updateGroup = ($this, val) => {
    var group = $this.data('group');
    var total = 0;
    var section = $this.data('section');
    $('.has' + section + 'Slider[data-group=' + group + ']')
        .not($this)
        .not('.slider-pool-' + section)
        .each(function () {
            var thisValue = $(this).slider('option', 'value');
            total += thisValue;
        });
    var maxTotal = $('.slider-pool-' + section + '[data-group=' + group + ']')
        .not('')
        .slider('option', 'max');
    if (total + val > maxTotal) {
        /* Assign maximum available value to the slider */
        $this.slider('option', 'value', maxTotal - total);
        /* Add value to the % displayed text */
        $this
            .closest('.row')
            .find('.slider-val-' + section)
            .text(maxTotal - total);

        $('.slider-pool-' + section).slider('option', 'value', maxTotal);
        return false;
    }
    $('.slider-pool-' + section).slider('option', 'value', total + val);
    return true;
};

document.addEventListener('DOMContentLoaded', function () {
    initializeTooltips();

    if ($('.group-slider').length) {
        $('.group-slider')
            .not('hasSlider')
            .each(function () {
                slidersInit($(this));
            });
    }

    if ($('.is-sortable').length) {
        $('.is-sortable').sortable({
            handle: '.handle',
            update: function (event, ui) {
                resetIndexes($(this).find('.tmpl').data('tmpl-name'));
            },
        });
    }

    if ($('.focus-select').length) {
        $('.focus-select').focus(function () {
            $(this).select();
        });
    }

    if ($('.select2').length) {
        $('.select2').each(function () {
            $(this).select2({
                tags: $(this).data('dynamic') ? true : false,
                selectionCssClass: 'ceplm',
                templateResult: function (data) {
                    // We only really care if there is an element to pull classes from
                    if (!data.element) {
                        return data.text;
                    }
                    var $element = $(data.element);
                    var $wrapper = $('<span></span>');
                    /* Add class to option */
                    $wrapper.addClass($element[0].className);
                    /* Add style attribute to option */
                    $wrapper.attr('style', $element[0].style.cssText);
                    $wrapper.text(data.text);
                    return $wrapper;
                },
            });
        });
    }
});
